import { NetworkSetup } from "../network-setup";
import { SKRT_ABI } from "./skrt-abi";
import { SKRT_STAKING_ABI_0x00d9d651993fbbdde720ee63ecc83a4b16b0da93 } from "./staking-0x00d9d651993fbbdde720ee63ecc83a4b16b0da93";
import { SKRT_STAKING_ABI_0xd876A265C624510cb1Cc02b1Bae1B7471868497a } from "./staking-0xd876A265C624510cb1Cc02b1Bae1B7471868497a";
import { USDT_ABI } from "./usdt-abi";
import { VERIFICATION_ABI } from "./verification-abi";

export const polygonNetworkSetup: NetworkSetup = {
  chain: "MATIC",
  contracts: {
    skrt: {
      address: "0xe51e88dd08499762b8e4eb3a9f3da9b8e79608c3",
      abi: SKRT_ABI,
      decimals: 18,
    },
    skrtStaking: {
      origins: {
        '0x00d9d651993FBbDdE720Ee63EcC83A4b16b0dA93': SKRT_STAKING_ABI_0x00d9d651993fbbdde720ee63ecc83a4b16b0da93,
        '0xd876A265C624510cb1Cc02b1Bae1B7471868497a': SKRT_STAKING_ABI_0xd876A265C624510cb1Cc02b1Bae1B7471868497a,
      },
      verification: {
        address: "0x004dba4F80551d23777fB276488b0D3818DC0904",
        abi: VERIFICATION_ABI,
      },
    },
    usdt: {
      decimals: 6,
      address: "0xc2132d05d31c914a87c6611c10748aeb04b58e8f",
      abi: USDT_ABI,
    },
  },
  purchase: () =>
    Promise.reject("purchasing is not supported for this network"),
  stake: () => Promise.reject("staking is not supported for this network"),
  unstake: () => Promise.reject("unstaking is not supported for this network"),
};
